/* eslint relay/must-colocate-fragment-spreads: off */
import {graphql, useFragment} from 'react-relay/hooks'
import {Box, Flex} from '@chakra-ui/react'
import {faMapMarkerAlt as farMapMarkerAlt} from '@fortawesome/pro-regular-svg-icons'

import {Header_provider$key} from './__generated__/Header_provider.graphql'
import defaultCover from './cover.jpg'

import {Avatar} from 'components/AvatarNew'
import {FontAwesomeIcon} from 'components/FontAwesomeIcon'
import {Heading} from 'components/Heading'
import {Image} from 'components/Image'

interface HeaderProps {
  provider: Header_provider$key
}

export function Header(props: HeaderProps) {
  const provider = useFragment(
    graphql`
      fragment Header_provider on Provider {
        ...Avatar_actor @arguments(size: 128)
        name
        cover {
          transformedSrc(maxHeight: 256, maxWidth: 1290)
        }
        city {
          name
          province {
            shortName
          }
        }
      }
    `,
    props.provider
  )

  return (
    <Box
      backgroundSize="cover"
      minH={[16, 24, 32, 256]}
      position="relative"
      style={{backgroundImage: `url('${defaultCover}')`}}
    >
      {provider.cover && (
        <Image minH="inherit" src={provider.cover.transformedSrc} />
      )}
      <Box
        backgroundImage="linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6))"
        bottom={0}
        left={0}
        position="absolute"
        right={0}
        top={0}
      />
      <Flex
        align="center"
        bottom={0}
        justify="center"
        left={0}
        position="absolute"
        right={0}
        top={0}
      >
        <Avatar
          actor={provider}
          borderRadius="full"
          boxShadow="md"
          h={[12, 20, 24, 128]}
          mr={[2, 4]}
          w={[12, 20, 24, 128]}
        />
        <Box>
          <Heading
            as="h1"
            color="white"
            fontSize={[`md`, `lg`, `2xl`]}
            fontWeight="medium"
          >
            {provider.name}
          </Heading>
          <Box color="white" fontSize="sm" fontWeight="normal" mt={1}>
            <FontAwesomeIcon icon={farMapMarkerAlt} />
            {` `}
            {provider.city.name}, {provider.city.province.shortName}
          </Box>
        </Box>
      </Flex>
    </Box>
  )
}
